export class DisposeUtils {
    isDisposed = false;
    private subscriptions: Unsubscribable[] = [];
    private disposeCallbacks: (() => void)[] = [];

    dispose() {
        this.isDisposed = true;
        for (const cb of this.disposeCallbacks) {
            cb();
        }
        for (const sub of this.subscriptions) {
            sub.unsubscribe();
        }
    }

    add(cb: (() => void) | Unsubscribable) {
        if (typeof cb === 'function') {
            this.disposeCallbacks.push(cb);
        } else {
            this.subscriptions.push(cb);
        }
    }
}

interface Unsubscribable {
    unsubscribe(): void;
}